import * as React from 'react';
import { Icon } from '../../components/Icon';
const MoveSvg = () => (React.createElement(React.Fragment, null,
    React.createElement("g", { clipPath: "url(#clip0_331:23610)" },
        React.createElement("path", { d: "M19.5 12L17 9.5V11.5H12.5V7H14.5L12 4.5L9.5 7H11.5V11.5H7V9.5L4.5 12L7 14.5V12.5H11.5V17H9.5L12 19.5L14.5 17H12.5V12.5H17V14.5L19.5 12Z", fill: "currentColor" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_331:23610" },
            React.createElement("rect", { width: "15", height: "15", fill: "white", transform: "translate(4.5 4.5)" })))));
export const MoveIcon = React.forwardRef((props, ref) => (React.createElement(Icon, { ref: ref, ...props },
    React.createElement(MoveSvg, null))));
